import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Landing from "./components/Landing";
import Traveller from "./components/Traveller";
import Patient from "./components/Patient";
import PhStats from "./components/PhStats";

function App() {
  return (
    <div>
      <Header />
      <div className="row bg-light ml-0 mr-0" style={{ height: "81vh" }}>
        <div className="col-md-3 bg-secondary text-white">
          <h6 className="pt-5">Live Statistics for the Philippines:</h6>
          <small>no data</small>
          {/* <PhStats /> */}
        </div>

        <div className="col-md-9">
          <Router>
            <Switch>
              <Route path="/traveller">
                <Traveller />
              </Route>
              <Route path="/patient">
                <Patient />
              </Route>
              <Route path="/">
                <Landing />
              </Route>
            </Switch>
          </Router>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;
